import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { AnimatedWand } from './components/AnimatedWand';

export const Hero: React.FC<EmptyProps> = () => {
	return (
		<section className="container pt-16 pb-16 md:pt-30 md:pb-32">
			<div className="mx-auto flex max-w-2xl flex-col items-center gap-4 text-center">
				<AnimatedWand />
				<Text size="small" fontWeight="bold" className="text-typography-weak uppercase">
					<Translate value="corgi.vision_page.title" />
				</Text>
				<Text as="h1" variant="heading" size="x-large" fontWeight="bold" data-qa="vision-hero-heading">
					<Translate value="corgi.vision_page.hero.heading" />
				</Text>
				<Text as="p" variant="body" size="large" className="text-typography-weak">
					<Translate value="corgi.vision_page.hero.body" />
				</Text>
			</div>
		</section>
	);
};
